// Polyfills for older browsers we still have to support.
//
// 2026-06-12: a user on Chrome 109 (Windows 7 — can't update past
// 109) hit `Uncaught TypeError: e.toSorted is not a function`
// inside mui-tel-input, which crashed the seafarer edit form. The
// ES2023 "change array by copy" methods (toSorted / toReversed /
// toSpliced / with) landed in Chrome 110, so they're missing on
// 109. They're plain methods (not syntax), so build-time
// transpilation can't add them — they need a runtime polyfill.
//
// Feature-detected + non-enumerable so we don't disturb anything
// on browsers that already have them.

const define = (proto, name, fn) => {
  if (typeof proto[name] === 'function') return;
  Object.defineProperty(proto, name, {
    value: fn,
    writable: true,
    configurable: true,
    enumerable: false,
  });
};

// Array.prototype.toSorted(compareFn)
define(Array.prototype, 'toSorted', function toSorted(compareFn) {
  return Array.prototype.slice.call(this).sort(compareFn);
});

// Array.prototype.toReversed()
define(Array.prototype, 'toReversed', function toReversed() {
  return Array.prototype.slice.call(this).reverse();
});

// Array.prototype.with(index, value) — copy with one element replaced
define(Array.prototype, 'with', function withValue(index, value) {
  const copy = Array.prototype.slice.call(this);
  const i = index < 0 ? copy.length + index : index;
  if (i < 0 || i >= copy.length) throw new RangeError('Invalid index');
  copy[i] = value;
  return copy;
});

// Array.prototype.toSpliced(start, deleteCount, ...items)
define(Array.prototype, 'toSpliced', function toSpliced(...args) {
  const copy = Array.prototype.slice.call(this);
  copy.splice(...args);
  return copy;
});
